export default __webpack_public_path__ + "static/media/longchamp4.a9296f1a.jpg";